import { types } from "react-bricks/frontend";
import { TrustWidgetLarge } from "components/molecules/TrustBox/TrustWidgetLarge";
import { StandardSection } from "components/templates/StandardSection";
import { P1 } from "components/atoms/Paragraph";
import styled from "styled-components";
import { mobile } from "components/templates/Breakpoints";
import {
  verticalPadSideProp,
  getVerticalPadding,
  VerticalPadding,
  VerticalPaddingWrapper,
} from "../utils/verticalPadding";

interface TrustpilotSectionProps {
  trustpilotText: string;
  paddingVertical?: VerticalPadding;
}

const TrustpilotSection: types.Brick<TrustpilotSectionProps> = ({
  trustpilotText,
  paddingVertical = "m",
}) => {
  return (
    <VerticalPaddingWrapper paddingVertical={paddingVertical}>
      <StandardSection pt="0" pb="0">
        <TrustWidgetLarge mt="5rem" />
        <TrustCopyWrap>
          <TrustCopy bold>
            {trustpilotText}{" "}
            <TrustImg src="/static/logos/TrustPilotLogo.svg" alt="Trustpilot logo" />
          </TrustCopy>
        </TrustCopyWrap>
      </StandardSection>
    </VerticalPaddingWrapper>
  );
};

const TrustCopyWrap = styled.div`
  display: flex;
  padding: 1rem 0;
  margin: auto;
  text-align: center;
`;

const TrustCopy = styled(P1)`
  font-size: 1rem;

  ${mobile} {
    line-height: 0.8rem;
  }
`;

const TrustImg = styled.img`
  position: relative;
  top: 0.35rem;
  left: -0.1rem;
`;

TrustpilotSection.schema = {
  name: "trustpilot-section",
  label: "Trustpilot Section",
  previewImageUrl: "  /static/bricks/trustpilot-section.png",
  getDefaultProps: () => ({
    trustpilotText: "We are the #1 rated employee benefits platform on",
    paddingVertical: "m",
  }),
  sideEditProps: [
    {
      name: "trustpilotText",
      label: "Trustpilot Text",
      type: types.SideEditPropType.Text,
    },
    verticalPadSideProp,
  ],
};

export default TrustpilotSection;
